import { createFileRoute } from "@tanstack/react-router";

import { BASE_COLOR } from "~/components/feature/balance/components/BalanceLongTermAssets";
import { DetailPage } from "~/components/feature/shared/components/DetailPage";

export const Route = createFileRoute(
  "/_app/dashboard/balance/long-term-assets/$category/detail",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category } = Route.useParams();

  return (
    <DetailPage
      tab="long-term-assets"
      category={category}
      targetMetric="balance"
      baseColor={BASE_COLOR}
    />
  );
}
